import styled from 'styled-components';

export const CardDetailWrapper = styled.div`
  color: #161d1f;
`;

export const CardDetailWrapperAmbient = styled.div``;

export const CardTagWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TagWrapper = styled.div<{
  card?: boolean;
}>`
  width: max-content;
  padding: 4px 12px;
  margin-bottom: 16px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  border-radius: 20px;
  color: #ffdbd0;
  background-color: #bd5c00;
`;

export const CardDetailGet = styled.div`
  position: relative;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    height: 1px;
    background-color: #d5e5f0;
  }

  > div {
    position: relative;
    z-index: 1;
    width: max-content;
    padding: 0 8px;
    margin: 0 auto;
    color: #161d1f;
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
  }
`;

export const CardDetailWrapperDetail = styled.div`
  /* border: 1px solid #a8cbe2; */
`;

export const CardDetailWrapperAddress = styled.div``;
